import { Injectable } from "@angular/core";
import { PageableResult } from "../models/domains/paginator/pageable-result";
import { Network } from "../models/domains/pbm/Benefit/network";
import { ExportOrderKey } from "../models/domains/pbm/exports/export-order-key";
import { NetworkFinancialStatementPagingRequest } from "../pages/network-financial-statement/network-financial-statement-paging-request";
import { NetworkRepository } from "../repositories/pbm/network.repository";

@Injectable({ providedIn: "root" })
export class NetworkFinancialService {
  constructor(private networkRepository: NetworkRepository) {}

  public async searchNetworkFinancialStatements(pagingRequest: NetworkFinancialStatementPagingRequest): Promise<PageableResult> {
    return this.networkRepository.searchNetworkFinancialStatements(pagingRequest);
  }

  public async findNetworkExportOrderKey(fiscalNumber: string, startAt: string, endAt: string): Promise<ExportOrderKey> {
    return this.networkRepository.findNetworkExportOrderKey(fiscalNumber, startAt, endAt);
  }
}
